import { graphql } from "~/gql";

export const UPDATE_MANY_TECHNOLOGY_RATES = graphql(/* GraphQL */ `
  mutation UpdateManyTechnologyRates($data: UpdateManyTechnologyRatesInput!) {
    updateManyTechnologyRates(data: $data) {
      count
    }
  }
`);
